<template>

	<div class="abow_wbox bkf7">
		<div class="inter">
			<div class="flex_box_bt">
				
				<div class="fr" style="width: 100%;">
					<h1 class="title">{{title}}</h1>
					<div class="con"  v-if="info && info.archivesInfo" v-html="info.archivesInfo.content">
						
					</div>
				</div>
			</div>
		</div>
	</div>

</template>


<script>
	export default {
		data() {
			return {
				list: [],
				content: "",
				active: 0,
				title:"",
                info:{}
			}
		},
		created: function(data) {

			this.getDetail();

		},
		watch: {
			$route() {

			}
		},
		methods: {
			getDetail() {
				var that = this;
				this.rq.requests.post("addons/cms/wxapp.Archives/detail2", {
					id: 4133,
				}).then(res => {
					that.info = res.data;
					
				}).catch(error => {
				
				})
			},

		}


	}
</script>
